import { useImpersonationHtmlTitlePrefix } from '@app/core/auth/impersonation/hooks/useImpersonationHtmlTitlePrefix';
import { Helmet } from 'react-helmet-async';

import { config } from '../../config';

interface Props {
  readonly text: string | string[];
}

/**
 * Sets the document title. While impersonating, prefixes with the effective client
 * (or email) so multiple browser tabs are distinguishable.
 */
export function HtmlTitle(p: Props) {
  const impersonationPrefix = useImpersonationHtmlTitlePrefix();
  const parts = Array.isArray(p.text) ? p.text : [p.text];
  const pagePart = parts.filter(Boolean).join(' | ');
  const withImpersonation = impersonationPrefix ? `${impersonationPrefix} · ${pagePart}` : pagePart;
  const title = `${withImpersonation} | MediaInbox` + (config.isAppDev ? ' (DEV)' : '');

  return (
    <Helmet defer={false}>
      <title>{title}</title>
    </Helmet>
  );
}
